import { Button } from 'common/components/Button/Button'
import { PrimeIcons } from 'primereact/api'
import { Dialog } from 'primereact/dialog'
import { Dispatch, SetStateAction, useState } from 'react'
import styled from 'styled-components'
import { IJobsListQuery } from './CommunityJobs'
import { CommunityJobsBaseFilters } from './CommunityJobsBaseFilters'

interface IProps {
  query: IJobsListQuery
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
  isLoading: boolean
}
export const CommunityJobsFiltersDialog = ({ query, setQuery, isLoading }: IProps) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button iconOnly size="large" onClick={() => setOpen(true)} aria-label="Open filters menu">
        <i style={{ fontSize: '1.3rem' }} className={PrimeIcons.FILTER}></i>
      </Button>

      {open && (
        <StyledDialog blockScroll visible={open} onHide={() => setOpen(false)} maximized>
          <div className="body-wrapper flex flex-column">
            <div className="flex-1 relative">
              <div className="scrollable-section p-3">
                <CommunityJobsBaseFilters query={query} setQuery={setQuery} />
              </div>
            </div>
            <div className="flex w-full align-items-center px-3">
              <Button
                isLoading={isLoading}
                className="flex-1 px-2 pb-2 mt-2"
                size="large"
                onClick={() => setOpen(false)}
              >
                View results
              </Button>
            </div>
          </div>
        </StyledDialog>
      )}
    </>
  )
}

const StyledDialog = styled(Dialog)`
  &.p-dialog {
    border-radius: 0;

    .p-dialog-content {
      padding: 0.5rem 1rem;
      overflow: hidden;
    }
  }
  height: 100%;
  overflow: hidden;

  .body-wrapper {
    height: 100%;
  }

  &.p-dialog .p-dialog-header,
  &.p-dialog .p-dialog-content {
    border-radius: 0 !important;
  }

  .scrollable-section {
    /* max-height: calc(100% - 60px); */
    position: absolute;
    inset: 0;
    overflow-y: auto !important;
  }
`
